import Header from '@components/Comman/Header';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import customelogo from '../../images/brand/customelogo.svg';
import { DashboardItemType } from '@typing/global';
import { dashboardInfoText, dashboardItemList, superAdminDashboardItemList } from '@utils/contstant';
import { useSelector } from 'react-redux';
import { sortDashboardItems } from '@utils/comman';
import { InfoCircleOutlined, LinkOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import { businessDefaultBisnessAction, businessDetailsAction, getAllBusinessCategories } from '../../actions/business';
import { getAllAdminNotificationCount, getBusinessIReferAction, getReferrerNotificationCount } from '../../actions/refer';
import { checkuser } from '../../actions/user';

const Dashboard = () => {
    const dispatch = useDispatch();
    const user = useSelector((state: any) => state?.Auth?.user);
    let userRole = user?.data?.roleId;
    const [dashboardList, setDashboardList] = useState([])
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const businessDetails = useSelector((state: any) => state?.Business?.businessDetails);
    const existingBusiness = useSelector((state: any) => state?.Business?.businessIReferList);
    const referralNotificationList = useSelector((state: any) => state?.Business?.referralNotificationList);
    const defaultBusinessDetails = useSelector((state: any) => state?.Business?.defaultBusinessDetails);
    const [ superAdminNotifyCount, setSuperAdminNotifyCount ] = useState({ business : 0 , referUs : 0, referNet : 0 , contactUs : 0 })


    useEffect(()=> {
        const payload = {
            businessCode: user?.businessCode
        }
        const payloadD = { limit: pageSize, page };
        if(userRole === 2 || userRole === 3) {
            dispatch(getBusinessIReferAction(payloadD, (resp: any) => {
                let delautBPayload = {
                    businessCode: resp?.data[0]?.senderCode 
                }
                userRole === 3 && dispatch(businessDefaultBisnessAction(delautBPayload, (resp: any) => {
                }));
                
            }));
        }
        userRole === 2 && dispatch(businessDetailsAction(payload, (resp: any) => {}));
        dispatch(getAllBusinessCategories({}, (resp: any) => {}));
    }, [userRole])

    useEffect(()=> {
        switch(userRole) {
            case 1: {
                setDashboardList(superAdminDashboardItemList)
                break;
            }
            case 2: {
                setDashboardList(dashboardItemList)
                break;
            }
            case 3: {
                setDashboardList(sortDashboardItems(dashboardItemList));
                break;
            }
            default: {
                break;
            }
        }
    }, [user])

    useEffect(()=> {
        // dispatch(checkuser((res: any) => { }));
        (userRole === 2) && dispatch(getReferrerNotificationCount({}, (res:any)=>{}))

        userRole === 1 && dispatch(
            getAllAdminNotificationCount({}, (resp: any) => {
                if (resp?.success) {
                    setSuperAdminNotifyCount({
                      business : resp?.data?.businessCount,
                      contactUs : resp?.data?.contact,
                      referUs : resp?.data?.referReferUsCount,
                      referNet : resp?.data?.rewards,
                    })
                }
            })
        );
    }, [userRole])

    const visibleCount = +referralNotificationList?.referralsCount || 0;
    const visibleCount1 = +referralNotificationList?.referrersCount || 0;
    return (
        <div>
            <Header pagTitle={userRole !== 3 ? "Dashboard" : ""} logo={defaultBusinessDetails?.BusinessDetails?.logoUrl} />
            <div className="contentBody">
                <div className="mobileView">
                    <div className="brandinglogo">
                        <img src={customelogo} alt="logo" />
                        <div className="text-center">
                            <div className="poweredby">Powered by @ReferUs</div>
                        </div>
                    </div>
                </div>{' '}
                <div className="row withCards">
                    {/* Invite A Referrer */}
                    {dashboardList?.map((item: DashboardItemType, index: number) => {
                        if (item?.role.includes(userRole)) {
                            let link = item?.path === '/businessLink' ? true : false;
                            const helpTextKey = item?.path?.split('/')?.[1];
                            return (
                                <div key={item?.id} className="col-lg-3 col-md-6  col-6">
                                    <Link to={link ? businessDetails?.url : item?.path} target={item?.path === '/businessLink' ? "_blank" : ""} className="dashboardCards position-relative">
                                        <div className="info-icon top-0 end-0">
                                            <Tooltip placement="top" title={dashboardInfoText?.[index]?.[helpTextKey]}>
                                                <InfoCircleOutlined style={{ color: 'gray' }} />
                                            </Tooltip>
                                        </div>
                                        {item?.name === 'My Referrals' ?
                                            visibleCount > 0 ?
                                                <div className='badge-icon '>
                                                    <span className='custom-badge-lg'>{visibleCount}</span>
                                                </div>
                                                : null
                                            : ""}
                                        {item?.name === 'My Referrers' ?
                                            visibleCount1 > 0 ? <div className='badge-icon '>
                                                <span className='custom-badge-lg'>{visibleCount1}</span>
                                            </div> : null
                                            : ""}
                                        {item?.name === 'Businesses' ?
                                            superAdminNotifyCount.business > 0 ? <div className='badge-icon '>
                                                <span className='custom-badge-lg'>{superAdminNotifyCount.business}</span>
                                            </div> : null
                                            : ""}
                                        {item?.name === 'Refer ReferUs' ?
                                            superAdminNotifyCount.referUs > 0 ? <div className='badge-icon '>
                                                <span className='custom-badge-lg'>{superAdminNotifyCount.referUs}</span>
                                            </div> : null
                                            : ""}
                                        {item?.name === 'ReferUs Network' ?
                                            superAdminNotifyCount.referNet > 0 ? <div className='badge-icon '>
                                                <span className='custom-badge-lg'>{superAdminNotifyCount.referNet}</span>
                                            </div> : null
                                            : ""}
                                        {item?.name === 'Contact Us' ?
                                            superAdminNotifyCount.contactUs > 0 ? <div className='badge-icon '>
                                                <span className='custom-badge-lg'>{superAdminNotifyCount.contactUs}</span>
                                            </div> : null
                                            : ""}
                                        <div className="navigationIcons">
                                            {link ? <LinkOutlined style={{ fontSize: '70px', color: '#F47523' }} /> : <img src={item?.icon} alt="icon" />}
                                        </div>
                                        <span>{item?.name}</span>
                                    </Link>
                                </div>
                            )
                        }
                    })}
                    {/* <div className="col-lg-3 col-md-6  col-6">
                        <Link to="/invite-referrer" className="dashboardCards">
                            <div className="navigationIcons">
                                <img src={Invite} alt="icon" />
                            </div>
                            <span>Invite A Referrer</span>
                        </Link>
                    </div> */}

                    {/* My Referrers */}
                    {/* <div className="col-lg-3 col-md-6  col-6">
                        <Link to="/myreferrers" className="dashboardCards">
                            <div className="navigationIcons">
                                <img src={MyReferrals} alt="icon" />
                            </div>
                            <span>My Referrers</span>
                        </Link>
                    </div> */}
                    {/* Businesses I Refer */}
                    {/* <div className="col-lg-3 col-md-6  col-6">
                        <Link to="/business-i-refer" className="dashboardCards">
                            <div className="navigationIcons">
                                <img src={Companies} alt="icon" />
                            </div>
                            <span>Businesses I Refer</span>
                        </Link>
                    </div> */}
                    {/* Businesses I Refer */}
                    {/* <div className="col-lg-3 col-md-6  col-6">
                        <Link to="/add-referral" className="dashboardCards">
                            <div className="navigationIcons">
                                <img src={AddReferral} alt="icon" />
                            </div>
                            <span>Add Referral</span>
                        </Link>
                    </div> */}
                    {/* My Referrals */}
                    {/* <div className="col-lg-3 col-md-6  col-6">
                        <Link to="/myreferrals" className="dashboardCards">
                            <div className="navigationIcons">
                                <img src={Referrals} alt="icon" />
                            </div>
                            <span>My Referrals</span>
                        </Link>
                    </div> */}


                    {/* Refer ReferUs */}
                    {/* <div className="col-lg-3 col-md-6  col-6">
                        <Link to="/refer-referus" className="dashboardCards">
                            <div className="navigationIcons">
                                <img src={ReferUS} alt="icon" />
                            </div>
                            <span> Refer ReferUs</span>
                        </Link>
                    </div> */}
                    {/* ReferUS Network */}
                    {/* <div className="col-lg-3 col-md-6  col-6">
                        <Link to="/referus-network" className="dashboardCards">
                            <div className="navigationIcons">
                                <img src={Network} alt="icon" />
                            </div>
                            <span>ReferUs Network</span>
                        </Link>
                    </div> */}
                    {/* Social Media */}
                    {/* <div className="col-lg-3 col-md-6  col-6">
                        <Link to="/social-media" className="dashboardCards">
                            <div className="navigationIcons">
                                <img src={Social} alt="icon" />
                            </div>
                            <span>Social Media</span>
                        </Link>
                    </div> */}

                    {/* Account */}
                    {/* <div className="col-lg-3 col-md-6  col-6">
                        <Link to="/account" className="dashboardCards">
                            <div className="navigationIcons">
                                <img src={account} alt="icon" />
                            </div>
                            <span>Account</span>
                        </Link>
                    </div> */}
                    {/* SetUp */}
                    {/* <div className="col-lg-3 col-md-6  col-6">
                        <Link to="/setup" className="dashboardCards">
                            <div className="navigationIcons">
                                <img src={setup} alt="icon" />
                            </div>
                            <span>Setup</span>
                        </Link>
                    </div> */}
                    {/* Help */}
                    {/* <div className="col-lg-3 col-md-6  col-6">
                        <Link to="/help" className="dashboardCards">
                            <div className="navigationIcons">
                                <img src={help} alt="icon" />
                            </div>
                            <span>Help</span>
                        </Link>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
